export const resources = {
  Hybrid: '',
  HeaderTrial: ''
};
